/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
import { MfeFramework } from "si-mfes-library/framework/mfe-framework";
import { environment } from "../../../environments/environments";

export class MfeFrameworkLoader {
  private readonly framework: MfeFramework;
  private readonly window: Window;

  constructor(window: Window, mfeFramework: MfeFramework) {
    this.framework = mfeFramework;
    this.window = window;
  }

  public async bootstrap(): Promise<any> {
    await this.loadEnvironmentCode();

    this.window[MfeFramework.SHELL_APP_KEY] = this.framework;
  }

  public getFramework() {
    return this.framework;
  }

  private async loadEnvironmentCode() {
    let environmentCode = null;
    try {
      const hostName = window.location.hostname;
      switch (hostName) {
        case environment.tdpINTHostname:
          environmentCode = "INT";
          break;
        case environment.tdpStagingHostname:
          environmentCode = "STAGING";
          break;
        case environment.tdpProdHostname:
          environmentCode = "PROD";
          break;
        case environment.tdpLocalHostname:
          environmentCode = "LOCAL";
          break;
        default:
          throw new URIError("Could not identify any TDP hostname");
      }
    } catch (e) {
      environmentCode = null;
    }
    this.window[MfeFramework.ENVIRONMENT_KEY] = {
      code: environmentCode,
    } as any;
  }
}
